import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from '@studio-freight/lenis';
import aiv from '../libs/aiv.lib';

aiv({ once: true, selector: '[data-text-slide]' });

gsap.registerPlugin(ScrollTrigger);

const lenis = new Lenis({
  duration: 1.3,
});

lenis.on('scroll', ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

// const scrollTriggerItems = document.querySelectorAll('[data-scroll]');
// if (scrollTriggerItems.length > 0) {
//   scrollTriggerItems.forEach((item) => {
//     const options = {
//       scrollTrigger: {
//         wrapper: '#smooth-wrapper',
//         content: '#smooth-content',
//         trigger: item.dataset.scrollTrigger,
//         scrub: +item.dataset.scrollDuration || 0,
//         start: item.dataset.scrollStart || 'top center',
//         end: item.dataset.scrollEnd || 'bottom center',
//         ignoreMobileResize: true,
//         once: item.dataset.once,
//       },
//       duration: 10,
//     };

//     if (item.dataset.scrollFromX || item.dataset.scrollFromY) {
//       gsap
//         .timeline(item, options)
//         .from(item, {
//           x: item.dataset.scrollFromX || 0,
//           y: item.dataset.scrollFromY || 0,
//           opacity: item.dataset.opacity || 0,
//           ...options,
//         })
//         .to(item, {
//           y: item.dataset.scrollY || 0,
//           x: item.dataset.scrollX || 0,
//           opacity: 1,
//           ...options,
//         });
//     } else {
//       gsap.to(item, {
//         y: item.dataset.scrollY || 0,
//         x: item.dataset.scrollX || 0,
//         ...options,
//       });
//     }
//   });
// }

const contactSection = document.querySelector('.contact-us');

if (contactSection) {
  const formWrap = contactSection.querySelector('.contact-us__form-wrap');
  const formPapper = contactSection.querySelector('.contact-us__form-papper');

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: formWrap,
      start: 'top-=200 center',
      end: 'center center',
      scrub: true,
      // markers: true,
    },
  });

  tl.from(formPapper, {
    yPercent: 30,
  }).to(formPapper, {
    yPercent: 0,
  });
}

const lenisScrollTo = (selector) => {
  const target = document.querySelector(selector);

  lenis.scrollTo(target, { offset: -40 });
};

window.lenisScrollTo = lenisScrollTo;

export default lenis;
